import { AnchorSquareIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/base-components';

interface ToggleButtonProps {
  onClick: () => void;
  isActive: boolean;
}

const ToggleButton = ({ onClick, isActive }: ToggleButtonProps) => {
  return (
    <Box
      onClick={onClick}
      width="32px"
      height="32px"
      maxWidth="32px"
      maxHeight="32px"
      padding={0}
      margin={0}
      bg={isActive ? 'secondaryLink' : 'background'}
      borderColor="transparent"
      borderRadius="4px"
      title={isActive ? 'Hide Sketch' : 'Show Sketch'}
      cursor="pointer"
    >
      <Box
        justify="center"
        align="center"
        height="100%"
        color={isActive ? 'background' : 'primaryText'}
      >
        <AnchorSquareIcon
          width={20}
          height={20}
          viewboxWidth={16}
          viewboxHeight={16}
        />
      </Box>
    </Box>
  );
};

export default ToggleButton;
